namespace $.$$ {
	
	$mol_style_define( $milis_skills_mod_input, {
		Mod_textarea: {
			opacity: 1,
			'@': {
				mod_disabled_by_level: {
					true: {
						opacity: 0.5,
					}
				}
			},
		}
	} )
	
}
